// extracted by mini-css-extract-plugin
module.exports = {"providerResponseContainer":"dataProviderResponse_providerResponseContainer__38-WI","section":"dataProviderResponse_section__2Va8O"};